import { render, staticRenderFns } from "./EditTransmitter.vue?vue&type=template&id=6d36d400&scoped=true&lang=pug"
import script from "./EditTransmitter.vue?vue&type=script&lang=js"
export * from "./EditTransmitter.vue?vue&type=script&lang=js"
import style0 from "./EditTransmitter.vue?vue&type=style&index=0&id=6d36d400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36d400",
  null
  
)

export default component.exports